/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartDischargeSummaryDetailsAliases {
  AVATAR = 'avatar',
  AVATAR_PROCESSING = 'avatar-processing',
  BUTTON_EMAIL = 'button-email',
  BUTTON_VIEW_PACS = 'button-view-pacs',
  BUTTON_VIEW_UNIFIED_DOCUMENTS = 'button-view-unified-documents',
  CARD_CONTAINER_BODY_EXAM = 'card-container-body-exam',
  CARD_CONTAINER_BODY_PROCESSING = 'card-container-body-processing',
  CARD_CONTAINER_EXAM = 'card-container-exam',
  CARD_CONTAINER_PROCESSING = 'card-container-processing',
  CARD_CONTAINER_ZONE_EXAM_AVATAR = 'card-container-zone-exam-avatar',
  CARD_CONTAINER_ZONE_EXAM_CONTENT = 'card-container-zone-exam-content',
  CARD_CONTAINER_ZONE_EXAM_DATE = 'card-container-zone-exam-date',
  CARD_CONTAINER_ZONE_EXAM_STATUS = 'card-container-zone-exam-status',
  CARD_CONTAINER_ZONE_PROCESSING_AVATAR = 'card-container-zone-processing-avatar',
  CARD_CONTAINER_ZONE_PROCESSING_CONTENT = 'card-container-zone-processing-content',
  CARD_CONTAINER_ZONE_PROCESSING_DATE = 'card-container-zone-processing-date',
  CARD_CONTAINER_ZONE_PROCESSING_STATUS = 'card-container-zone-processing-status',
  CARD_CONTAINER_ZONE_VIEW = 'card-container-zone-view',
  CONTEXTUAL_BAR_CHANGING_DOCUMENTS = 'contextual-bar-changing-documents',
  CONTEXTUAL_BAR_DISCHARGE_SUMMARY_DETAILS = 'contextual-bar-discharge-summary-details',
  CONTEXTUAL_BAR_EXAM_RESULT = 'contextual-bar-exam-result',
  DECK_ENCOUNTER_EXAMS_AVAILABLE = 'deck-encounter-exams-available',
  DECK_EXAM_DETAILS_PROCESSING = 'deck-exam-details-processing',
  DECK_SUMMARY_DETAILS = 'deck-summary-details',
  FETCH_ENCOUNTER_EXAMS = 'fetch-encounter-exams',
  FETCH_ENCOUNTER_PROCESSING = 'fetch-encounter-processing',
  FETCH_SUMMARY_DETAILS = 'fetch-summary-details',
  FIELD_AVATAR = 'field-avatar',
  FIELD_AVATAR_PROCESSING = 'field-avatar-processing',
  FIELD_EXAM = 'field-exam',
  FIELD_EXAM_DATE = 'field-exam-date',
  FIELD_EXAM_DATE_PROCESSING = 'field-exam-date-processing',
  FIELD_EXAM_DETAIL = 'field-exam-detail',
  FIELD_EXAM_DETAIL_PROCESSING = 'field-exam-detail-processing',
  FIELD_EXAM_PROCESSING = 'field-exam-processing',
  FIELD_EXAM_STATUS = 'field-exam-status',
  FIELD_EXAM_STATUS_PROCESSING = 'field-exam-status-processing',
  FIELD_PACS = 'field-pacs',
  FRAGMENT_REFERENCE_CHANGING_DOCUMENTS = 'fragment-reference-changing-documents',
  IMAGE_EXAM_STATUS = 'image-exam-status',
  IMAGE_EXAM_STATUS_PROCESSING = 'image-exam-status-processing',
  LAYOUT_DISCHARGE_SUMMARY_DETAILS = 'layout-discharge-summary-details',
  LOADER_PDF = 'loader-pdf',
  MAPPER_EXAMS_AVAILABLE = 'mapper-exams-available',
  MAPPER_EXAMS_PROCESSING = 'mapper-exams-processing',
  MY_CHART_DISCHARGE_SUMMARY_APPOINTMENT_DETAILS_CARD = 'my-chart-discharge-summary-appointment-details-card',
  MY_CHART_DISCHARGE_SUMMARY_DETAILS_CARD = 'my-chart-discharge-summary-details-card',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_CHANGING_DOCUMENTS = 'panel-changing-documents',
  PANEL_DISCHARGE_SUMMARY_DETAILS = 'panel-discharge-summary-details',
  PANEL_EXAM_RESULT = 'panel-exam-result',
  PANEL_LOADER = 'panel-loader',
  PANEL_REPORT = 'panel-report',
  PDF_VIEWER = 'pdf-viewer',
  TAB_CONTROL_EXAMS = 'tab-control-exams',
  TAB_WITH_CONTENT_AVAILABLE = 'tab-with-content-available',
  TAB_WITH_CONTENT_PROCESSING = 'tab-with-content-processing',
  TEXT_EXAM = 'text-exam',
  TEXT_EXAM_DATE = 'text-exam-date',
  TEXT_EXAM_DATE_PROCESSING = 'text-exam-date-processing',
  TEXT_EXAM_DETAIL = 'text-exam-detail',
  TEXT_EXAM_DETAIL_PROCESSING = 'text-exam-detail-processing',
  TEXT_EXAM_PROCESSING = 'text-exam-processing',
  TEXT_EXAM_STATUS = 'text-exam-status',
  TEXT_EXAM_STATUS_PROCESSING = 'text-exam-status-processing',
}
export { MyChartDischargeSummaryDetailsAliases };
